<div class="flex-left-column light-control-host">
  <h1 class="panel-title flex-center-row">Failback for "{{ appName }}"</h1>
  <div class="margin-top">
    A <em>failback</em> is the reverse of a failover. It copies the data from your recovery environment to your existing
    infrastucture in the primary environment. A failback does not impact the application running in the recovery
    environment, so you can test failback as many times as you like. For more details, see the
    <a href="{{ failbackDocsUrl }}" target="_blank">failback documentation</a>.
  </div>
  <div class="margin-top"><h3>Select applications to failback</h3></div>
  <!-- Select All Checkbox -->
  <div class="select-all-container resource-type flex-center-row margin-top" *ngIf="applications.length > 0">
    <input
      type="checkbox"
      class="arpio-checkbox"
      [checked]="areAllApplicationsSelected()"
      (change)="toggleSelectAllApplications($event.target.checked)"
      [disabled]="applications.length === 0"
    />
    <div class="select-all-label" (click)="toggleSelectAllApplications(!areAllApplicationsSelected())">
      {{ areAllApplicationsSelected() ? 'Deselect All' : 'Select All' }}
    </div>
  </div>
  <div class="flex-center-row full-width margin-top">
    <div id="applicationSelectionList" class="light-content-panel dialog-selection-list spacer">
      <div class="flex-center-row" *ngFor="let application of applications">
        <input
          id="app-id"
          class="arpio-checkbox"
          type="checkbox"
          (input)="toggleApplicationSelection(application.applicationObj.applicationId)"
          [checked]="applicationIsChecked(application.applicationObj)"
        />
        <div class="application-name margin-left">{{ application.applicationObj.name }}</div>
      </div>
    </div>
  </div>
  <div></div>
  <div *ngIf="loading; else connectBlock" class="margin-top">
    <h1><i class="fa-solid fa-spinner fa-spin"></i> Checking for AWS connectivity</h1>
  </div>
  <ng-template #connectBlock>
    <h3 class="margin-top">Failback Access</h3>
    <div *ngIf="failbackAccessInitiallyAllGood; else accessBlock" class="margin-top">
      It looks like Arpio already has the right access to perform a failback.
    </div>
  </ng-template>
  <ng-template #accessBlock>
    <div *ngIf="!failbackAccessInitiallyAllGood">
      Arpio needs some extra permissions for your environment to failback. You can remove these later.
    </div>
    <aws-account-access-view
      class="margin-top"
      [state]="failbackAccessService.state"
      [stackName]="failbackAccessService.stack"
      [accessType]="Scope.FAILBACK"
      [templateUrl]="failbackAccessTemplate"
      [awsAccountId]="application.sourceAwsAccountId"
      [region]="application.sourceRegion"
      [completedTestCount]="failbackAccessService.tests"
      (buttonClicked)="failbackAccessService.validateAccess()"
    >
    </aws-account-access-view>
  </ng-template>
  <div class="flex-center-row double-margin-top full-width">
    <div class="spacer"></div>
    <button class="arpio-secondary-button" (click)="onCancelClick()">CANCEL</button>
    <button
      busy-button
      id="failback-button"
      class="arpio-button margin-left"
      [busy]="launching"
      [disabled]="notReadyToFailback || launching"
      (click)="onFailbackClick()"
    >
      FAILBACK
    </button>
    <div class="spacer"></div>
  </div>
</div>
